import { useEffect, useState } from 'react';
import { useStyletron } from 'baseui';
import { StyledLink } from 'baseui/link';
import { TableBuilder, TableBuilderColumn } from 'baseui/table-semantic';
import { toaster } from 'baseui/toast';
import { HeadingMedium } from 'baseui/typography';
import { getUnmappedProjects } from '@gtintel/platform-api';
import { useAsyncOp } from '@gtintel/platform-utils';
import ContentContainer from '../ContentContainer';
import SaveButton from './SaveButton';
import TypesCombobox from './TypesCombobox';
export function ProjectTypeMappingPanel() {
  const [css] = useStyletron();
  const [rows, setRows] = useState([]);
  const [updatedRows, setUpdatedRows] = useState([]);
  const {
    isLoading,
    fn: getProjects
  } = useAsyncOp(getUnmappedProjects);
  const [isFirstRender, setIsFirstRender] = useState(true);
  useEffect(() => {
    getProjects().then(data => {
      setRows(data);
      setIsFirstRender(false);
    }).catch(error => {
      toaster.negative('Error fetching unmapped projects', error);
    });
  }, [updatedRows, isFirstRender]);
  const updateRowType = (id, newType) => {
    setUpdatedRows(prevRows => {
      const existingRowIndex = prevRows.findIndex(row => row.id === id);
      if (existingRowIndex !== -1) {
        return prevRows.map(row => row.id === id ? {
          ...row,
          type: newType
        } : row);
      } else {
        const rowToUpdate = rows.find(row => row.id === id);
        return [...prevRows, {
          ...rowToUpdate,
          type: newType
        }];
      }
    });
  };
  return <ContentContainer>
      <HeadingMedium>Project Types</HeadingMedium>
      <TableBuilder data={rows} emptyMessage="All done!" isLoading={isLoading && isFirstRender} loadingMessage="Loading...">
        <TableBuilderColumn header="Project Name">
          {row => <div className={css({
          minWidth: '400px'
        })}>
              <StyledLink href={`/admin/project/detail/${row.id}`} target="_blank">
                {row.name}
              </StyledLink>
            </div>}
        </TableBuilderColumn>
        <TableBuilderColumn header="Client">
          {row => <div className={css({
          minWidth: '200px'
        })}>{row.client}</div>}
        </TableBuilderColumn>
        <TableBuilderColumn header="Project Type">
          {row => <div className={css({
          minWidth: '200px'
        })}>
              <TypesCombobox row={row} onTypeChange={updateRowType} />
            </div>}
        </TableBuilderColumn>
      </TableBuilder>
      <SaveButton updatedRows={updatedRows} onSave={setIsFirstRender} />
    </ContentContainer>;
}
export default ProjectTypeMappingPanel;